import { chatEvents, cookieConstant, messageResponseTypes } from "@/services/constants"
import { getCookie } from '@/services/cookie'
import { v4 as uuidV4 } from 'uuid'
import cloneDeep from 'lodash/cloneDeep'
import { decodeBase64UrlSafe } from '@/services/utils'

export default {
  handleSecureForm ({ commit, rootState }, eventData) {
    const { subType, eventInfo, timestamp } = eventData || {}
    const payload = eventInfo?.payload
    switch (subType) {
        case chatEvents.CARD_INFO:
            {
              const ts = timestamp || Date.now()
              const conversationId = getCookie(cookieConstant.SESSION.CONVERSATION_ID)
              const request = {
                isUser: false,
                hide: false,
                messages: [
                  {
                    messageId: uuidV4(),
                    type: messageResponseTypes.SECURE_FORM_RESPONSE,
                    isUser: false,
                    timestamp: ts,
                    conversationId,
                      messageValue: {
                        formId: payload?.formId || String(ts),
                        heading: payload?.heading,
                        description: payload?.body,
                        ctaText: payload?.ctaText,
                        maxWaitTime: payload?.maxWaitTime || 20000,
                        status: 'PENDING',
                        isClicked: false
                      }
                  }
                ],
                timestamp: ts
              }
              commit('UPDATE_CHATS', request)
            }
            break;
        case chatEvents.LINK_GENERATION:
            {
              const { formId } = payload || {}
              if (!formId) break
              const chats = rootState.chats || []
              for (let position = chats.length - 1; position >= 0; position--) {
                const block = chats[position]
                const msgIndex = (block?.messages || []).findIndex(
                  m => m?.type === messageResponseTypes.SECURE_FORM_RESPONSE && m?.messageValue?.formId === formId
                )
                if (msgIndex !== -1) {
                  const updatedBlock = cloneDeep(block)
                  updatedBlock.messages[msgIndex].messageValue = {
                    ...updatedBlock.messages[msgIndex].messageValue,
                    isClicked: true
                  }
                  commit('UPDATE_CHAT_AT_ITH_POS', { position, chatBlock: updatedBlock })
                  break
                }
              }
            }
            break;
        case chatEvents.SECURE_LINK:
            {
              const { formId, link, openIn } = payload || {}
              if (!formId || !link) break
              const chats = rootState.chats || []
              for (let position = chats.length - 1; position >= 0; position--) {
                const block = chats[position]
                const msgIndex = (block?.messages || []).findIndex(
                  m => m?.type === messageResponseTypes.SECURE_FORM_RESPONSE && m?.messageValue?.formId === formId
                )
                if (msgIndex !== -1) {
                  const updatedBlock = cloneDeep(block)
                  updatedBlock.messages[msgIndex].messageValue = {
                    ...updatedBlock.messages[msgIndex].messageValue,
                    link: decodeBase64UrlSafe(link),
                    openIn: (openIn || updatedBlock.messages[msgIndex].messageValue?.openIn || 'cw-iframe').toLowerCase(),
                    isClicked: true
                  }
                  commit('UPDATE_CHAT_AT_ITH_POS', { position, chatBlock: updatedBlock })
                  break
                }
              }
            }
            break;
        case chatEvents.FORM_STATUS:
            {
              const { formId, heading, body, ctaText, status } = payload || {}
              if (!formId || !status) break
              const normStatus = (Array.isArray(status) ? status?.[0] : status)?.toUpperCase()
              const chats = rootState.chats || []
              for (let position = chats.length - 1; position >= 0; position--) {
                const block = chats[position]
                const msgIndex = (block?.messages || []).findIndex(
                  m => m?.type === messageResponseTypes.SECURE_FORM_RESPONSE && m?.messageValue?.formId === formId
                )
                if (msgIndex !== -1) {
                  const updatedBlock = cloneDeep(block)
                  const prev = updatedBlock.messages[msgIndex].messageValue || {}
                  const sanitizedPrev = { ...prev }
                  delete sanitizedPrev.link
                  delete sanitizedPrev.openIn
                  updatedBlock.messages[msgIndex].messageValue = {
                    ...sanitizedPrev,
                    ...(heading ? { finalHeading: heading } : {}),
                    ...(body ? { finalBody: body } : {}),
                    ...(ctaText ? { finalCtaText: ctaText } : {}),
                    isClicked: true,
                    status: normStatus
                  }
                  commit('UPDATE_CHAT_AT_ITH_POS', { position, chatBlock: updatedBlock })
                  break
                }
              }
            }
            break;
    }
  }
}
